import { Chip } from '@mui/material';

import Card from '@/components/wrapped/Card';
import { type PublishedShortlist } from '@/north-star/care/shortlists/fixtures';

// One published shortlist as a card in the care search list: name, a provider
// count + last-updated subtitle, and a "n secured" chip once the family has
// secured anyone on it. Built on the wrapped Card.
const ShortlistSummaryCard = ({
  shortlist,
  onOpen,
}: {
  shortlist: PublishedShortlist;
  onOpen: (shortlist: PublishedShortlist) => void;
}) => {
  const securedCount = shortlist.providers.filter(
    (p) => p.status === 'Secured',
  ).length;
  const countLine = `${shortlist.providers.length} ${
    shortlist.providers.length === 1 ? 'provider' : 'providers'
  } · ${shortlist.updated}`;

  return (
    <Card
      title={shortlist.name}
      titleVariant='h4'
      subtitle={countLine}
      chip={
        securedCount > 0 ? (
          <Chip
            size='small'
            color='success'
            label={`${securedCount} secured`}
          />
        ) : undefined
      }
      onClick={() => onOpen(shortlist)}
    />
  );
};

export default ShortlistSummaryCard;
